import { render } from "./product-catelog.vue?vue&type=template&id=185dad94"
import script from "./product-catelog.vue?vue&type=script&lang=js"
export * from "./product-catelog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__